import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { illustration } from '../../common/illustrations';
const KEY = 'voucha-assessment-code';
const store = {
  get: () => {
    try {
      return localStorage.getItem(KEY) || '';
    } catch (e) {
      return '';
    }
  },
  set: v => {
    try {
      localStorage.setItem(KEY, v);
    } catch (e) {}
  },
  clear: () => {
    try {
      localStorage.removeItem(KEY);
    } catch (e) {}
  }
};

/**
 * /assessments/claim?code=...  The last step of a quiz on okjapa.com.
 * Signed out: sign up or log in (Flarum reloads this page afterwards, so the code in the address is used then;
 * it is also kept in this browser in case a social sign-in leaves the page). Signed in: the answers are attached
 * to the account and the member goes to their results.
 */
export default class ClaimPage extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle('Save your results');
    app.setTitleCount(0);
    let code = '';
    try {
      code = m.route.param('code') || '';
    } catch (e) {}
    if (code) store.set(code);else code = store.get();
    // People arriving from okjapa.com: their "Follow topics" popup shows life-abroad tags and places (voucha-theme)
    try {
      localStorage.setItem('voucha-topic-focus', JSON.stringify({
        focus: 'diaspora',
        at: Date.now()
      }));
    } catch (e) {}
    this.code = code;
    this.error = code ? null : 'This link is missing its code. Please take the quiz again on okjapa.com.';
    this.busy = false;
    if (code && app.session.user) this.claim();
  }
  async claim() {
    this.busy = true;
    m.redraw();
    try {
      const res = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/assessment-results/claim',
        body: {
          code: this.code
        },
        errorHandler: () => {}
      });
      store.clear();
      m.route.set(app.route('voucha-assessments.result', {
        id: res.id
      }), null, {
        replace: true
      });
      return;
    } catch (e) {
      store.clear();
      this.error = e?.response?.error || 'Your results could not be saved. Please try again.';
    }
    this.busy = false;
    m.redraw();
  }
  open(which) {
    const loader = which === 'login' ? () => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal') : () => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal');
    try {
      const shown = app.modal.show(loader);
      if (shown && shown.catch) shown.catch(() => {});
    } catch (e) {}
  }
  view() {
    return m("div", {
      className: "VAssessClaim container"
    }, m("div", {
      className: "VAssessClaim-card"
    }, m("span", {
      className: "VAssessClaim-pic",
      "aria-hidden": "true"
    }, m.trust(illustration(this.error ? 'map-cross' : 'compass'))), this.error ? this.errorView() : this.busy ? this.busyView() : this.signedOutView()));
  }
  busyView() {
    return [m("h1", null, "Saving your results\u2026"), m(LoadingIndicator, null)];
  }
  errorView() {
    return [m("h1", null, "We couldn't find those results"), m("p", null, this.error), m("a", {
      className: "Button Button--primary",
      href: "https://okjapa.com/japa-compass"
    }, "Take the Japa Compass")];
  }
  signedOutView() {
    return [m("h1", null, "Your Japa Compass results are ready"), m("p", {
      className: "VAssessClaim-lead"
    }, "Create a Voucha account to see your full results, compare countries side by side, and talk with Nigerians who made the same move."), m("div", {
      className: "VAssessClaim-actions"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.open('signup')
    }, "Create an account"), m(Button, {
      className: "Button",
      onclick: () => this.open('login')
    }, "I already have an account")), m("p", {
      className: "VAssessClaim-note"
    }, "Your answers stay private to your account. If you don't save them, they are deleted after 7 days.")];
  }
}
flarum.reg.add('voucha-assessments', 'forum/components/ClaimPage', ClaimPage);